/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { connect } from 'react-redux';
// import dateFns from 'date-fns';
import * as dateFns from 'date-fns';
import pt from 'date-fns/locale/pt-BR';
import Typography from '@material-ui/core/Typography';
import Select from 'react-select';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Tour from 'reactour';

import './calendar.css';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import CalendarModalContent from '../../components/CalendarModalContent/CalendarModalContent';
import { fetchEmployees } from '../../store/actions/employee';
import axios from '../../config/axiosInstance';


class Calendar extends React.Component {
  state = {
    currentMonth: new Date(),
    selectedOption: null,
    selectedDate: new Date(),
    currentSelect: {},
    isTourOpen: false,
    data: null,
    lisEmployees: []
  };

  componentDidMount() {
    // this.props.onFetchEmployees();
    this.getListEmployees();
  }

  getListEmployees = async () => {
    const result = await axios.get('/employee/list')
    this.setState({ lisEmployees: result.data })
  }

  onDateClick = (day) => {
    if (this.state.data) {
      this.setState({
        selectedDate: day,
        currentSelect: {
          day,
          detailed: this.state.data.itens[dateFns.getDate(day) - 1],
        },
      });
    }
  };

  getData(d) {
    const info = this.divergencias.filter(item => item.dia === d)[0] || {};

    if (info.tipo === 0) {
      info.classe = '';
    }

    if (info.isDivergent && info.tipo !== 4) {
      info.classe = 'divergente';
    }

    if (this.state.selectedOption && this.state.selectedOption.isfired) {
      const start = dateFns.format(this.state.selectedOption.dtdemission);
      const end = dateFns.format(this.state.selectedOption.dtlastdaywork);
      const day = dateFns.format(info.dtRef);

      if (day >= start && day <= end) {
        info.classe = 'desligando';
      }
    }

    return info;
  }

  divergencias = [];
  detailed = [];

  closeTour = () => {
    this.setState({ isTourOpen: false });
  };

  openTour = () => {
    this.setState({ isTourOpen: true });
  };

  handleSelectChange = (selectedOption) => {
    this.setState({
      selectedOption,
    }, () => {
      this.requestDaysInfo();
    });
  }

  isSelected = day => this.divergencias.length && dateFns.format(day, 'yyyy-MM-dd') === dateFns.format(this.state.selectedDate, 'yyyy-MM-dd')

  nextMonth = () => {
    this.setState({
      currentMonth: dateFns.addMonths(this.state.currentMonth, 1),
    }, () => {
      if (this.state.selectedOption) {
        this.requestDaysInfo();
      }
    });
  };

  prevMonth = () => {
    this.setState({
      currentMonth: dateFns.subMonths(this.state.currentMonth, 1),
    }, () => {
      if (this.state.selectedOption) {
        this.requestDaysInfo();
      }
    });
  };

  reload = () => {
    this.requestDaysInfo();
    this.forceUpdate();
  };

  renderLabels() {
    return (
      <div className="labels">
        <div className="label-container">
          <div className="label divergente" style={{ textAlign: 'center', lineHeight: '1.25' }} />
          <span><b>Divergências</b> ({this.state.data && this.state.data.itens ? this.state.data.itens.filter(item => item.isDivergent).length : '0'})</span>
        </div>
      </div>
    );
  }


  renderHeader() {
    const dateFormat = 'MMMM yyyy';

    return (
      <div className="header calendar-row row-middle">
        <div className="calendar-col calendar-col-start">
          <div className="calendar-icon" onClick={this.prevMonth} onKeyDown={() => { }} role="button" tabIndex="0">
            <i className="material-icons">
              arrow_back_ios
            </i>
          </div>
        </div>
        <div className="calendar-col calendar-col-center" style={{ minWidth: '150px' }}>
          <span>
            {dateFns.format(this.state.currentMonth, dateFormat, { locale: pt })}
          </span>
        </div>

        <div className="calendar-col calendar-col-end">
          <div className="calendar-icon" onClick={this.nextMonth} onKeyDown={() => { }} role="button" tabIndex="0">
            <i className="material-icons">
              arrow_forward_ios
            </i>
          </div>
        </div>
      </div>
    );
  }

  renderDays() {
    const dateFormat = 'EEE';
    const days = [];
    const startDate = dateFns.startOfWeek(this.state.currentMonth);
    for (let i = 0; i < 7; i += 1) {
      days.push((
        <div
          style={{ color: 'rgba(0, 0, 0, 0.54)' }}
          className="calendar-col calendar-col-center"
          key={i}
        >
          {dateFns.format(dateFns.addDays(startDate, i), dateFormat, { locale: pt })}
        </div>
      ));
    }
    return <div className="days calendar-row">{days}</div>;
  }

  findDayColor = (day, monthStart) => {
    if (this.state.data) {
      if (dateFns.isSameMonth(day, monthStart)) {
        const currentDay = this.state.currentSelect.day;
        const dayDetails = this.state.data.itens[dateFns.getDate(day) - 1];

        let almostFired = false;
        //
        if (dayDetails && dayDetails.isDivergent) {
          if (this.state.selectedOption && this.state.selectedOption.isfired) {
            const start = this.state.selectedOption.dtdemission;
            const end = this.state.selectedOption.dtlastdaywork;
            const d = day;


            if (d >= start && d <= end) {
              almostFired = true;
            } else {
              almostFired = false;
            }
          }
        }
        //


        if (!this.state.data) {
          return { backgroundColor: 'unset' };
        }

        if (dateFns.isSameDay(day, currentDay)) {
          if (dayDetails.isDivergent && almostFired) {
            return { backgroundColor: '#ffcc33', color: 'white' };
          }
          if (dayDetails.isDivergent && !almostFired) {
            return { backgroundColor: '#ea5d6c', color: 'white' };
          }
          return { backgroundColor: '#537ccd', color: 'white' };
        }

        if (dayDetails && dayDetails.isDivergent) {
          if (this.state.selectedOption && this.state.selectedOption.isfired) {
            // const start = dateFns.format(this.state.selectedOption.dtdemission);
            // const end = dateFns.format(this.state.selectedOption.dtlastdaywork);
            // const d = dateFns.format(day);


            if (almostFired) {
              return { backgroundColor: '#F8DD4E4D', color: 'black' };
            }
            return { backgroundColor: '#FFBEBE', color: 'black' };
          }

          return { backgroundColor: '#FFBEBE', color: 'black' };
        }
      }
    }

    return { backgroundColor: 'unset' };
  }

  renderCells() {
    const { currentMonth } = this.state;
    const monthStart = dateFns.startOfMonth(currentMonth);
    const monthEnd = dateFns.endOfMonth(monthStart);
    const startDate = dateFns.startOfWeek(monthStart);
    const endDate = dateFns.endOfWeek(monthEnd);


    const dateFormat = 'd';
    const rows = [];
    let days = [];
    let day = startDate;
    let formattedDate = '';

    while (day <= endDate) {
      for (let i = 0; i < 7; i += 1) {
        formattedDate = dateFns.format(day, dateFormat, { locale: pt });
        const cloneDay = day;
        // const dayInfo = this.getData(parseInt(dateFns.format(day, 'D'), 10));
        days.push((
          <div
            className={`calendar-col cell ${dateFns.isSameMonth(day, monthStart) || 'disabled'}`}
            style={this.findDayColor(day, monthStart)}
            key={day}
            onClick={() => this.onDateClick(cloneDay)}
          >
            {/* <span className="day-type">{dateFns.isSameMonth(day, monthStart) && (dayInfo && dateFns.isSameMonth(dayInfo.dtRef, monthStart)) ? dayInfo.msg : ''}</span> */}
            <Typography variant="body1">{formattedDate}</Typography>
          </div>
        ));
        day = dateFns.addDays(day, 1);
      }

      rows.push(<div className="calendar-row" key={day}>{days}</div>);
      days = [];
    }

    return <div className="body">{rows}</div>;
  }


  requestDaysInfo() {
    const monthStart = dateFns.format(dateFns.startOfMonth(this.state.currentMonth), 'yyyy-MM-dd', { locale: pt });
    const monthEnd = dateFns.format(dateFns.endOfMonth(this.state.currentMonth), 'yyyy-MM-dd', { locale: pt });

    // new start
    axios.post('/timeSheet/generate/pointSheet/monthlyTracking', {
      start: `${monthStart} 00:00:00`,
      end: `${monthEnd} 23:59:00`,
      //employees: this.props.history.push(`/acompanhamento/${this.state.selectedOption.id}`) ? [this.state.selectedOption.id] : -1,
      employees: this.state.selectedOption ? [this.state.selectedOption.id] : -1,
      showCosts: true,
      holidayV2: true,
    })
      .then((result) => {
        const today = this.state.currentSelect.day || new Date();
        this.setState({
          data: result.data,
          currentSelect: { day: today, detailed: result.data.itens[today.getDate() - 1] },
        });
      });

    // end
  }

  render() {
    // const { employees } = this.props;
    const accentColor = '#537ccd';
    const { isTourOpen, lisEmployees } = this.state;
    //this.setState({ selectedOption: this.props.match.params.id });
    const options = lisEmployees.map((i) => {
      i.value = i.id;
      i.label = i.name;
      return i;
    });

    const optionsEmployee = options.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });

    return (
      <div>
        <div className="calendar">
          <ContentHeader
            title="Acompanhamento"
            subtitle="Acompanhe e edite horas baixadas, abonos e lista de pontos"
          >
            <Button color="primary" onClick={this.openTour} >Está com Duvidas?</Button>
          </ContentHeader>
          <Tour
            onRequestClose={this.closeTour}
            steps={tourConfig}
            isOpen={isTourOpen}
            maskClassName="mask"
            className="helper"
            rounded={5}
            accentColor={accentColor}
          />

          <Paper elevation={2} style={{ padding: '25px' }}>
            <div className="display-flex">
              <div style={{ width: '40%', marginRight: '10%' }} data-tut="reactour__Select">
                <Typography variant="body2" align="left" color="textPrimary">
                  Escolha um usuário para visualizar suas informações
                </Typography>
                <Select
                  options={optionsEmployee}
                  styles={
                    {
                      option: (styles, state) => ({
                        ...styles,
                        backgroundColor: state.isSelected ? '#2684FF' : state.data.isfired ? '#F8DD4E4D' : '',
                      }),
                    }}
                  onChange={this.handleSelectChange}
                  placeholder="Busque um usúario"
                />
              </div>
            </div>

            <div style={{ display: 'flex', marginTop: '20px' }}>
              <div style={{ flexBasis: '40%' }}>
                <div style={{ width: '100%' }}>
                  <div style={{ padding: '10px' }}>
                    {this.renderHeader()}
                    {this.renderDays()}
                    {this.renderCells()}
                    {this.renderLabels()}
                  </div>

                </div>
              </div>

              <div style={{ flexBasis: '60%' }}>
                <Paper elevation={2} >
                  <CalendarModalContent
                    day={this.state.currentSelect.day}
                    detailed={this.state.currentSelect.detailed || { mock: true }}
                    close={this.reload}
                    worker={this.state.selectedOption}
                    hasOffline={this.state.currentSelect.detailed ? (this.state.currentSelect.detailed.insOffline.length || this.state.currentSelect.detailed.outsOffline.length) : null}
                  />
                </Paper>
              </div>
            </div>
          </Paper>
        </div>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  loading: state.general.loading,
  // employees: state.employee.employees,
});

const mapDispatchToProps = dispatch => ({
  // onFetchEmployees: () => dispatch(fetchEmployees()),
});

const tourConfig = [
  {
    selector: '[data-tut="reactour__Select"]',
    content: 'Começe escolhendo o colaborador e o dia que pretende fazer a gestão dos pontos  ',
  },
  {
    selector: '[data-tut="reactour__edit"]',
    content: 'Anule o ponto ou faça alterações',
  },
  {
    selector: '[data-tut="reactour__MoreInfo"]',
    content:
      'Aqui você pode Adicionar o Ponto ou Abonar e Validar o dia de trabalho.',
  },
  {
    selector: '[data-tut="."]',
    content:
      <React.Fragment>
        Dúvidas? visite nosso blog!
        <Button
          href="https://blog.puntu.digital/post-acompanhamento/"
          color="primary"
        >
          Ver nosso post
        </Button>
      </React.Fragment>,
  },

];

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
